import { Box, Grid, Heading, Text, VStack, HStack, Button } from '@chakra-ui/react';
import React, { useState } from 'react';
import { TABS } from 'const';

export const Solutions: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('desktop');

  const currentTab = TABS.find((tab) => tab.id === activeTab) || TABS[0];

  return (
    <Box py={16} id="platforms">
      <VStack>
        <VStack textAlign="center">
          <Heading size="xl">Multi-Platformalı Həll</Heading>
          <Text fontSize="lg" color="gray.600" maxW="600px">
            Bir sistem, müxtəlif platformalar - biznesinizi istənilən yerdən, istənilən vaxt idarə
            edin.
          </Text>
        </VStack>

        <Box bg="gray.100" borderRadius="xl" p={1} w={{ base: '100%', md: 'auto' }}>
          <HStack flexWrap="nowrap" justifyContent="center">
            {TABS.map((tab) => (
              <Button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                variant="ghost"
                borderRadius="lg"
                px={{ base: 2, md: 6 }}
                py={6}
                fontSize={{ base: 'sm', md: 'md' }}
                bg={activeTab === tab.id ? 'white' : 'transparent'}
                color={activeTab === tab.id ? 'green.600' : 'gray.700'}
                fontWeight={activeTab === tab.id ? '600' : 'normal'}
                _hover={{
                  bg: activeTab === tab.id ? 'white' : 'gray.200'
                }}
                boxShadow={activeTab === tab.id ? 'sm' : 'none'}
                transition="all 0.2s"
                whiteSpace="nowrap"
              >
                <HStack>
                  <Text display={{ base: 'none', md: 'unset' }}>{tab.icon}</Text>
                  <Text display={{ sm: 'block' }}>{tab.label}</Text>
                </HStack>
              </Button>
            ))}
          </HStack>
        </Box>

        <Grid
          templateColumns={{
            base: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)'
          }}
          gap={6}
          w="100%"
        >
          {currentTab.solutions.map((solution, index) => (
            <VStack
              key={index}
              align="start"
              p={6}
              bg="white"
              borderRadius="xl"
              border="1px solid"
              borderColor="gray.200"
              transition="all 0.3s"
              _hover={{
                shadow: 'lg',
                transform: 'translateY(-4px)',
                borderColor: 'green.300'
              }}
            >
              <Box fontSize="3xl">{solution.icon}</Box>
              <Heading size="md" color="gray.800">
                {solution.title}
              </Heading>
              <Text color="gray.600" fontSize="sm">
                {solution.description}
              </Text>
            </VStack>
          ))}
        </Grid>
      </VStack>
    </Box>
  );
};
